import { iframeResizer } from 'iframe-resizer';
import { onDomReady } from '../utils/dom';

// ChurchTools measures its height while its container still shows a scrollbar, because the iframe starts lower than
// the content. Without the scrollbar the content gets wider and full-width images get taller, so with classic
// scrollbars (Edge) the scrollbar would come back and stay empty. The slack also covers the truncated pixel fraction.
const HEIGHT_SLACK = 20;

function churchToolsIframes() {
    const resizedIframes = new WeakSet();

    // Checks the host of the current src: a blocked iframe points to the cookiebar
    // with the ChurchTools URL in its redirect parameter and must not be resized yet
    function isChurchToolsIframe(iframe) {
        try {
            return new URL(iframe.src, window.location.href).hostname === 'evjuc.church.tools';
        } catch {
            return false;
        }
    }

    function initResize(iframe) {
        if (resizedIframes.has(iframe)) return;
        if (!isChurchToolsIframe(iframe)) return;
        resizedIframes.add(iframe);

        iframeResizer(
            {
                checkOrigin: ['https://evjuc.church.tools'],
                // The ChurchTools body is as high as the iframe, so the default bodyOffset only reports the current height
                heightCalculationMethod: 'lowestElement',
                // Ignores the slack added in onResized, which the full-height ChurchTools container reports back
                tolerance: HEIGHT_SLACK,
                onResized: ({ iframe: resizedIframe, height }) => {
                    resizedIframe.style.height = `${Number(height) + HEIGHT_SLACK}px`;
                },
            },
            iframe,
        );
    }

    // Handle iframes already in the DOM on script load
    document.querySelectorAll('iframe').forEach(initResize);

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            // Handle iframes that get added later
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    if (node.tagName === 'IFRAME') initResize(node);
                });
            }

            // Handle iframes getting unblocked via the cookiebar
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'src' &&
                mutation.target.tagName === 'IFRAME'
            ) {
                initResize(mutation.target);
            }
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src'],
    });
}

// The registration iframes are embedded without a title, screen readers would only announce "frame"
function titleChurchToolsIframes() {
    const heading = document.querySelector('h1')?.textContent.trim();

    for (const iframe of document.querySelectorAll('iframe:not([title])')) {
        // While blocked by the cookiebar, the ChurchTools URL is only in data-src
        if (!/^https:\/\/evjuc\.church\.tools\//.test(iframe.dataset.src || iframe.src)) continue;

        iframe.title = heading ? `Anmeldung: ${heading}` : 'Anmeldung';
    }
}

onDomReady(() => {
    titleChurchToolsIframes();
    churchToolsIframes();
});
